export const FETCH_QUESTIONS = "FETCH_QUESTIONS";
export const FETCH_QUESTIONS_FULFILLED = "FETCH_QUESTIONS_FULFILLED";
export const UPSERT_QUESTION = "UPSERT_QUESTION";
export const UPSERT_QUESTION_FULFILLED = "UPSERT_QUESTION_FULFILLED";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const DELETE_QUESTION_FULFILLED = "DELETE_QUESTION_FULFILLED";
export const SET_SETTINGS_NAVIGATION = "SET_SETTINGS_NAVIGATION";
